import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PUPIL_FEATURE_KEY, PupilState, pupilAdapter } from './pupil.reducer';
import {
  selectRouteNestedParam,
  selectRouteNestedParams,
} from '@lyceo/shared/data-access';
import { CallState, LoadingState } from '@lyceo/shared/util-loading';

export const selectPupilState =
  createFeatureSelector<PupilState>(PUPIL_FEATURE_KEY);

const { selectAll, selectEntities } = pupilAdapter.getSelectors();

export const selectAllPupils = createSelector(
  selectPupilState,
  (state: PupilState) => selectAll(state),
);

export const selectPupilEntities = createSelector(
  selectPupilState,
  selectEntities,
);

export const selectParamPupilId = selectRouteNestedParam('pupilId');

export const selectParamPupil = createSelector(
  selectPupilEntities,
  selectRouteNestedParams,
  (pupils, { pupilId }) => pupils[pupilId],
);

export const selectParamPupilLoaded = createSelector(
  selectParamPupil,
  (pupil) => !!pupil,
);

export const selectParamPupilLoading = createSelector(
  selectParamPupilLoaded,
  (loaded: boolean) => !loaded,
);

export const selectParamPupilAddress = createSelector(
  selectParamPupil,
  (pupil) => {
    if (!pupil) {
      return undefined;
    }
    return {
      email: pupil.emailAddress,
      phone: pupil.phoneNumber,
    };
  },
);

export const selectParamPupilImportantPersonIds = createSelector(
  selectParamPupil,
  (pupil) => pupil?.importantPersonIds,
);

export const selectProfileCallState = createSelector(
  selectPupilState,
  (state) => state.profileCallState,
);

export const selectProfileFinishedLoading = createSelector(
  selectProfileCallState,
  (callState: CallState) =>
    callState !== LoadingState.INIT && callState !== LoadingState.LOADING,
);

export const selectCoursesCallState = createSelector(
  selectPupilState,
  (state) => state.coursesCallState,
);
